import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  secondStepWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text: {
    color: theme.palette.text.secondary,
  },
  buttonClose: {
    minWidth: 130,
    marginTop: 20,
  },
}));
